module.exports = __webpack_public_path__ + "static/img/H52.94d9174.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/H52.png
// module id = XBsv
// module chunks = 3